// extracted by mini-css-extract-plugin
module.exports = {"card":"FacetCard_card__eIEeK","imageRatio":"FacetCard_imageRatio__E0LF_","image":"FacetCard_image__R2M3j","link":"FacetCard_link__odM3N","title":"FacetCard_title__XcJhc"};